var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#528AEA",
  fillRule: "evenodd",
  d: "M16.317 9.65V7.888H9.332V.904H7.57v6.984H.586V9.65H7.57v6.985h1.762V9.65z"
})));
export default __webpack_public_path__ + "teg/media/plus-theme.f006adb1.svg";
export { SvgComponent as ReactComponent };